module.exports = __webpack_public_path__ + "img/roadtrip.5afc91bd.svg";